import styled from 'styled-components/macro'
import { GridHeader } from '../../../../components/Reusable/Grid'

export const ControlsGridHeader = styled(GridHeader)<{ $color?: string }>`
  min-width: 85px;
  justify-content: ${(p) => p.justifyContent || 'flex-start'};
  z-index: 1;
  ${({ $color }) => $color && `color: ${$color}`}
`

export const EvidenceSubHeaders = styled.div`
  display: flex;
  justify-content: space-evenly;
  > div {
    display: flex;
    justify-content: center;
    width: 120px;
  }
`

export const StatusHeader = styled(ControlsGridHeader)`
  min-width: 176px;
`

export const SpinnerContainer = styled.div<{ isFullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5em;
  left: 0;
  right: 0;
  text-align: center;
  div {
    width: ${(p) => (p.isFullWidth ? '100%' : '')};
  }
`
